// Track clicks on Zalo / phone links (form submissions are already tracked
// via the contacts table). Uses one delegated listener, so any new tel: or
// zalo.me link is tracked automatically.

// Ordered: first matching ancestor wins.
var PLACEMENTS = [
  ['.modal', 'modal'],
  ['.mobile-cta-stack', 'mobile_stack'],
  ['.floating-zalo', 'floating_zalo'],
  ['.navbar', 'navbar'],
  ['.footer', 'footer'],
  ['.advisor-profile', 'advisor_profile'],
  ['.sidebar', 'sidebar'],
  ['.contact-channels', 'contact_page']
];

function ctaKind(href) {
  if (href.indexOf('tel:') === 0) return 'phone';
  if (href.indexOf('zalo.me/') >= 0) return 'zalo';
  return null;
}

function ctaPlacement(el) {
  var explicit = el.closest('[data-cta-placement]');
  if (explicit) return explicit.getAttribute('data-cta-placement');
  for (var i = 0; i < PLACEMENTS.length; i++) {
    if (el.closest(PLACEMENTS[i][0])) return PLACEMENTS[i][1];
  }
  return 'other';
}

document.addEventListener('click', function(event) {
  var link = event.target.closest && event.target.closest('a[href]');
  if (!link) return;
  var kind = ctaKind(link.getAttribute('href') || '');
  if (!kind) return;

  var placement = ctaPlacement(link);

  if (window.dataLayer) {
    window.dataLayer.push({ event: 'cta_click', cta_kind: kind, cta_placement: placement });
  }

  var data = new FormData();
  data.append('kind', kind);
  data.append('placement', placement);
  data.append('path', location.pathname);
  if (navigator.sendBeacon) {
    navigator.sendBeacon('/cta_clicks', data);
  } else {
    fetch('/cta_clicks', { method: 'POST', body: data, keepalive: true });
  }
}, true);
